import { api } from '@shared-runtime/api';

import type { GetCurrenciesParams, GetCurrenciesResult } from './apiSchema';
import { normalizeGetCurrencies } from './helpers';
import type { GetCurrenciesResponse } from './schema';

/**
 * BFF：获取所有Fiat货币激活状态
 *
 * 1. GET /fiat/get-applications - 获取所有货币状态
 * 2. GET /fiat/get-accept-terms - 检查T&C接受状态
 * 3. GET /fiat/get-edd-status - 获取EDD/POA状态（仅Retail用户）
 *
 */
export async function fetchGetCurrencies(
  params: GetCurrenciesParams = {},
): Promise<GetCurrenciesResponse> {
  return api.bff
    .get<GetCurrenciesResult>('/v1/private/fiat/get-fiat-currencies', params)
    .normalize(normalizeGetCurrencies);
}
